import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { ButtonController, IButtonControllerOptions } from '../../../Common/ButtonController';
import { GameLogic } from '../../../Logic/GameLogic';
import { GameModel } from '../../../Models/GameModel';

export enum ShopNeedleItemTypeEnum {
    needle_1 = 'needle_1',
    needle_2 = 'needle_2',
    needle_3 = 'needle_3',
    ball_1 = 'ball_1',
    ball_2 = 'ball_2',
    ball_3 = 'ball_3',
}

export enum ShopNeedleItemBenefitTypeEnum {
    none,
    benefit,
    playerChoice,
}

export interface IShopNeedleItemControllerOptions {
    type: ShopNeedleItemTypeEnum;
    price: number;
    count: number;
    benefitValue?: number;
    benefitType: ShopNeedleItemBenefitTypeEnum;
}

export class ShopNeedleItemController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IShopNeedleItemControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('ShopLifeItemOpenedController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                btn_buy: {
                    instanceName: 'button',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            // this._gameLogic.addBalanceLeaves(this._options.count); TODO refactoring
                        },
                        onFreameSet: (frame: number) => {
                            this.setSizeLabelButton(frame);
                        },
                    },
                },
            },
        };
    }

    protected onInitialize() {
        this.gotoAndStopByQuery('icon', this._options.type);

        if (this._options.benefitType === ShopNeedleItemBenefitTypeEnum.benefit) {
            this.gotoAndStopByQuery('benefit', 'benefit');
            this.setTextByQuery('benefit.txt_value', `${this._options.benefitValue}%`);

        } else if (this._options.benefitType === ShopNeedleItemBenefitTypeEnum.playerChoice) {
            this.gotoAndStopByQuery('benefit', 'player_choice');

        } else {
            this.getDisplayObjectByQuery('benefit')[0].visible = false;
        }

        const btnLabel = this.getDisplayObjectByQuery('button.txt_price')[0] as PIXI.Text;
        btnLabel.text = this._options.price.toString();
        btnLabel.x += btnLabel.width / 2;
        btnLabel.y += btnLabel.height / 2;
        btnLabel.anchor.set(0.5);

        const countLabel = this.getDisplayObjectByQuery('txt_count')[0] as PIXI.Text;
        countLabel.text = ` x${this._options.count.toFixed()}`;
    }

    private setSizeLabelButton(frame: number) {
        const btnLabel = this.getDisplayObjectByQuery('button.txt_price')[0] as PIXI.Text;
        btnLabel.scale.set(frame === 1 ? 1.2 : 1);
    }
}
